import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  GetLoanTemplatesForSetadResponse,
  PaginationInfo,
  SearchLoanRequestsRequest,
  SearchLoanRequestsResponse,
} from "../../models/loan.model";

import {
  Box,
  Button,
  FormControl,
  Grid,
  SelectChangeEvent,
  Tooltip,
  Typography,
} from "@mui/material";
import { GetStatusResponse } from "../../models/basicInformation.model";
import {
  LOAN_REQUEST_STATUS_SETAD,
  LOAN_TEMPLATE_SETAD,
  SUPPLIERIDS,
  SUPPLIER_ATTACHMENTS_UPLOADED,
  SUPPLIER_SETTLEMENT_STATUS_SETAD,
  TABLE_FILTER_SUPP,
  TABLE_FILTER_SUPP_ROWNumber,
  WORK_FLOW_TYPE,
} from "../../config/cacheKey";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useHistory, withRouter } from "react-router-dom";
import { createTheme } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import createCache from "@emotion/cache";
import useCollapse from "react-collapsed";
import { useEffect, useState } from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { Filter } from "../../models/chat.model";
import { connect, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import MultiSelectChip from "../../components/dropdown/MultiSelectChip";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import ChipCmp from "../../components/chip/chipCmp";
import ChipComponent from "../../components/chip/chipComponent";
import {
  exportLoanRequests,
  GetLoanRequestStatuses,
  searchLoanRequests,
} from "../../services/loan.service";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import {
  GetLoanRequestStatus,
  GetLoanTemplatesForSetad,
  GetSupplierSettlementStatus,
  GetSuppliers,
} from "../../services/basicInformation.service";
import { datePickerValueManager } from "@mui/x-date-pickers/DatePicker/shared";
import { debug } from "console";
import { FilterFinder } from "../../models/cartable.model";
import { createStyles, Theme, makeStyles } from "@material-ui/core";
import Autocomplate from "../../components/dropdown/Autocomplate";
import { ChatSearch } from "../../services/chat.service";
import { ChatSearchRequest, ChatSearchResponse } from "../../models/chat.model";
import { cartableSet } from "../../redux/activeCartable/activeCartableSlice";
import { seenNotification } from "../../redux/comments/commentSlice";
import { v4 } from "uuid";
import { ConfirmHasTheUserSeen } from "../../services/chat.service";
import AutocomplateCheckbox from "../../components/dropdown/AutocomplateCheckbox";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src='images/Next.png' />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src='images/Previous.png' />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "creatorFullName", label: "ثبت کننده" },
  {
    id: "receiverFullName",
    label: "ارجاع گیرنده",
  },
  {
    id: "creationDatePersian",
    label: "تاریخ و زمان",
  },
  {
    id: "messageText",
    label: "عنوان پیام",
  },
  {
    id: "customerNationalCode",
    label: "کد ملی مشتری",
  },
  {
    id: "loanTemplateTitle",
    label: "نام طرح",
  },
  {
    id: "loanAmount",
    label: "مبلغ تسهیلات",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  // { id: "customerFullName", label: "پذیرنده" },
  // {
  //   id: "loanRequestStatusUpdateDatePersian",
  //   label: "...",
  // },
];
let muiSelected: any;

function CommentsTable({ stateCartable, status }: TableCmpPropsInterface) {
  let row: any;
  const queryClient = useQueryClient();

  const activePage = localStorage.getItem("setActivePage");
  queryClient.setQueryData(WORK_FLOW_TYPE, undefined);
  const oldPage = queryClient.getQueryData<FilterFinder>(
    TABLE_FILTER_SUPP_ROWNumber
  );
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
    openChatDrawer: boolean;
    loanRequestId: number;
    natinalCode: string;
  }>();
  const [isExpanded, setExpanded] = useState(false);

  const [valueCustomerFullName, setValueCustomerFullName] = React.useState<
    string
  >();
  const [
    valueCustomerNationalCode,
    setValueCustomerNationalCode,
  ] = React.useState<string>();
  const [
    valueCustomerMobileNumber,
    setValueCustomerMobileNumber,
  ] = React.useState<string>();
  const [valueRequestDate, setValueRequestDate] = React.useState<string>();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();

  const [
    valueSettlementStatusDate,
    setValueSettlementStatusDate,
  ] = React.useState<string>();
  const [
    valueSupplierSettlementStatus,
    setValueSupplierSettlementStatus,
  ] = useState<string[]>([]);
  const [valueLoanTemplateOptions, setValueLoanTemplateOptions] = useState<
    string[]
  >([]);
  const [valueLoanTemplate, setValueLoanTemplate] = useState<any[]>([]);
  const [valueSupplierIds, setValueSupplierIds] = useState<string[]>([]);
  const [valueSupplier, setValueSupplier] = useState<any[]>([]);

  const [valueMultiSelect, setValueMultiSelect] = React.useState<string[]>([]);
  const [valueSupplierUserOptions, setValueSupplierUserOptions] = useState([]);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  const [data, setData] = React.useState<ChatSearchResponse[]>([]);
  const [excelData, setExcelData] = React.useState();

  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );

  const [loanRequestOptions, setLoanRequestOptions] = React.useState<
    GetStatusResponse[]
  >([]);

  const [loanTemplateOptions, setLoanTemplateOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [loanRequestStatus, setLoanRequestStatus] = React.useState<
    GetStatusResponse[]
  >([]);

  const [
    supplierSettlementOptions,
    setSupplierSettlementOptions,
  ] = React.useState<GetStatusResponse[]>([]);
  const [supplierIdsOptions, setSupplierIdsOptions] = React.useState<
    GetStatusResponse[]
  >([]);

  const [requestDate, setRequestDate] = React.useState<
    Date[] | null | undefined
  >(null);
  // const [requestDateTo, setRequestDateTo] = React.useState<Date | null | undefined>(null);
  const [settlementStatusDate, setSettlementStatusDate] = React.useState<
    Date[] | null | undefined
  >(null);
  const [valueMultiSelectResponse, setValueMultiSelectResponse] = useState<
    any[]
  >([]);

  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  const disposeListener = history.listen((navData) => {
    if (
      navData.pathname === "/Report/OnlineInstallment" &&
      history.location.state !== undefined &&
      history.location.state.pageNumber!
    ) {
      currentPaginationInfo.pageNumber = history.location.state.pageNumber;
      setCurrentPaginationInfo(currentPaginationInfo);
    }
  });
  React.useEffect(() => {
    if (history.action === "POP" && oldPage?.rowNumber != undefined) {
      row = queryClient.getQueryData(TABLE_FILTER_SUPP_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber == undefined
    ) {
      row = undefined;
      setSelectedRow(row);
    }
    if (history.action === "POP" && oldPage?.rowNumber == undefined) {
      row = undefined;
      setSelectedRow(row);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber != undefined
    ) {
      row = queryClient.getQueryData(TABLE_FILTER_SUPP_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    let filterData;

    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
      if (filterData !== undefined && filterData !== null) {
        setValueMultiSelect(filterData!.loanRequestStatus!);
        setValueSupplierSettlementStatus(filterData!.supplierSettlementStatus!);
        // setValueLoanTemplateOptions(filterData?.loanTemplateIds!);
        // setValueLoanTemplate(filterData!.valueLoanTemplate!);
        // setValueSupplierIds(filterData?.supplierIds!);
        // setValueSupplier(filterData?.supplierName!);
        setValueCustomerFullName(filterData?.customerFullName!);
        setValueCustomerNationalCode(filterData?.customerNationalCode!);
        setValueCustomerMobileNumber(filterData?.customerMobileNumber!);
        // setValueRequestDate(filterData?.requestDatePersian!);
        // setRequestDate(filterData?.requestDateArray);
        // setValueSettlementStatusDate(filterData?.settlementStatusDatePersian!);
        // setSettlementStatusDate(filterData?.settlementStatusDateArray);
      }
    } else {
      // filter.state = stateCartable.stateCartable;
      filterData = new Filter();
      filterData.customerFullName = "";
      filterData.customerNationalCode = "";
      filterData.customerMobileNumber = "";
      filterData.loanTemplateIds = [];
      filterData.supplierIds = [];
      filterData.loanRequestStatus = [];
      filterData.supplierSettlementStatus = [];
      // filterData.requestDatePersian = "";
      // filterData.settlementStatusDatePersian = "";
      // filterData.requestDateArray = [];
      // filterData.settlementStatusDateArray = [];
      queryClient.setQueryData(TABLE_FILTER_SUPP, null);
    }
    fillData(filterData!);
    const filterSupp = new FilterFinder();
    filterSupp.state = stateCartable.stateCartable;
    queryClient.setQueryData(TABLE_FILTER_SUPP_ROWNumber, filterSupp);
  }, [stateCartable]);

  const SearchLoanRequestsMutation = useMutation(ChatSearch, {
    onSuccess: (result: ApiResultModel<ChatSearchResponse[]>) => {
      if (result) {
        setData(result.data);
        setPageInfo(result.pageInfo);
      }
    },
  });

  const ExportLoanRequestsMutation = useMutation(exportLoanRequests, {
    onSuccess: (result) => {},
    onError: (e) => {},
  });

  const { mutate: UserSeenMutation } = useMutation(ConfirmHasTheUserSeen, {
    onSuccess: (data: boolean) => {
      if (data) {
      }
    },
    onError: () => {},
  });

  function setChildValueStat(childValues: any) {
    const selectedItem = valueMultiSelect.filter(
      (item: any) => item != childValues
    );
    setValueMultiSelect(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.loanRequestStatus = tabelFilter!.loanRequestStatus
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  }
  const setChildValueStatSettelment = (childValues: any) => {
    const selectedItem = valueSupplierSettlementStatus.filter(
      (item: any) => item != childValues
    );
    setValueMultiSelectResponse(
      valueMultiSelectResponse.filter((item) => item.id !== childValues)
    );
    setValueSupplierSettlementStatus(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.supplierSettlementStatus = tabelFilter!.supplierSettlementStatus
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueLoanTemplate = (childValues: any) => {
    const selectedItem = valueLoanTemplateOptions.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueLoanTemplate.filter(
      (item: any) => item.id != childValues
    );
    setValueLoanTemplateOptions(selectedItem);
    setValueLoanTemplate(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.loanTemplateIds = tabelFilter!.loanTemplateIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
      // tabelFilter!.valueLoanTemplate = tabelFilter!.valueLoanTemplate
      //   ?.filter((item: any) => item.id != childValues)
      //   .map((items: any) => {
      //     return items;
      //   });
    }
    fillData(tabelFilter!);
  };
  const setChildValueSupplierIds = (childValues: any) => {
    const selectedItem = valueSupplierIds.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueSupplier.filter(
      (item: any) => item.id != childValues
    );
    setValueSupplierIds(selectedItem);
    setValueSupplier(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.supplierIds = tabelFilter!.supplierIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }

    fillData(tabelFilter!);
  };
  const setChildValueCustomerFullName = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerFullName(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerFullName = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerNationalCode = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueCustomerMobileNumber = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerMobileNumber(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerMobileNumber = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueRequestDate = (childValues: any) => {
    const selectedItem = "";

    setValueRequestDate(selectedItem);
    //    setRequestDateFrom(undefined);
    setRequestDate(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.requestDateFrom = undefined;
      tabelFilter!.requestDateTo = undefined;
      // tabelFilter!.requestDatePersian = "";
      // tabelFilter!.requestDateArray = [];
    }
    fillData(tabelFilter!);
  };

  const setChildValueSettlementStatusDate = (childValues: any) => {
    const selectedItem = "";

    setValueSettlementStatusDate(selectedItem);
    setSettlementStatusDate(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      // tabelFilter!.settlementStatusDatePersian = "";
      // tabelFilter!.settlementStatusDateArray = [];
      tabelFilter!.settlementStatusDateFrom = undefined;
      tabelFilter!.settlementStatusDateTo = undefined;
    }

    fillData(tabelFilter!);
  };

  const { mutate: GetLoanRequestStatusesMutate } = useMutation(
    GetLoanRequestStatuses,
    {
      onSuccess: (data: GetStatusResponse[]) => {
        if (data) {
          setLoanRequestStatus(data);
        }
      },
      onError: () => {},
    }
  );
  useEffect(() => {
    GetLoanRequestStatusesMutate();
  }, []);

  const generateFilter = (filterData: Filter): ChatSearchRequest => {
    let request = new ChatSearchRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    // if (request.filter != undefined)
    //   request.filter.cartableTitle = "پرونده های تسهیلات";

    //checked
    // request.filter.state = stateCartable.stateCartable;
    return request;
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    SearchLoanRequestsMutation.mutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    changePageNumber(newPage + 1);
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    alert("handleChangeRowsPerPage");
    // setRowsPerPage(+event.target.value);
    // setPage(0);
  };

  const handleChangeMultiselect = (
    event: SelectChangeEvent<typeof loanRequestOptions>
  ) => {
    const {
      target: { value },
    } = event;
  };
  const dispatch = useDispatch();
  const handleDetail = (
    referenceKey: string,
    rowIndex: number,
    loanRequestId: number,
    natinalCode: string
  ) => {
    window.sessionStorage.setItem("id", referenceKey);
    window.sessionStorage.setItem("loanRequestId", loanRequestId.toString());
    window.sessionStorage.setItem("natinalCode", natinalCode);
    handleSelectRow(rowIndex);
    currentPaginationInfo.rowNumber = rowIndex;
    queryClient.setQueryData(SUPPLIER_ATTACHMENTS_UPLOADED, null);
    //history.push(`/loan-detail/${referenceKey}`);

    dispatch(
      seenNotification({
        hasSeened: v4(),
      })
    );

    UserSeenMutation({ referenceKey: referenceKey });

    dispatch(cartableSet({ cartable: "LoanRegistrationBySupplier" }));
    localStorage.setItem("setActivePage", "LoanRegistrationBySupplier");
    history.push({
      pathname: `/loan/LoanRegistrationBySupplier1/loan-detail-find`,
      state: {
        id: referenceKey,
        from: "",
        pageNumber: currentPaginationInfo.pageNumber!,
        clickOnBack: false,
        openChatDrawer: true,
        loanRequestId: loanRequestId,
        natinalCode: natinalCode,
      },
    });
  };
  const handleSelectRow = (rowIndex: any) => {
    const cachPageNumber = queryClient.getQueryData(
      TABLE_FILTER_SUPP_ROWNumber
    ) as FilterFinder;
    const filter = new FilterFinder();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    queryClient.setQueryData(TABLE_FILTER_SUPP_ROWNumber, filter);
  };
  function handelCollapse() {
    setExpanded(!isExpanded);
  }
  function changeMultiSelectChip(e: any, value: any) {
    setValueMultiSelect(e);
    setValueMultiSelectResponse(value);
  }
  function changeValueSupplierSettlementStatus(e: any) {
    setValueSupplierSettlementStatus(e);
  }
  function changeValueLoanTemplateOptions(e: any, value: any) {
    setValueLoanTemplateOptions(e);
    setValueLoanTemplate(value);
  }
  function changeValueSupplierIds(e: any, value: any) {
    setValueSupplierIds(e);
    setValueSupplier(value);
  }
  function changeValueCustomerFullName(e: any) {
    setValueCustomerFullName(e.currentTarget.value);
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget.value);
  }
  function changeValueCustomerMobileNumber(e: any) {
    setValueCustomerMobileNumber(e.currentTarget.value);
  }
  function changeValueRequestDate(e: any) {
    setValueRequestDate(e.toString().replace(/,/g, " - "));
    setRequestDate(e);
  }

  function changeValueSettlementStatusDateFrom(e: any) {
    setSettlementStatusDate(e);
    setValueSettlementStatusDate(e.toString().replace(/,/g, " - "));
  }

  function deleteChip() {
    setValueMultiSelect([]);
    setValueSupplierSettlementStatus([]);
    setValueLoanTemplateOptions([]);
    setValueLoanTemplate([]);
    setValueSupplierIds([]);
    //test pazirande
    setValueSupplier([]);
    setValueCustomerFullName("");
    setValueCustomerNationalCode("");
    setValueCustomerMobileNumber("");
    setValueRequestDate("");
    setValueSettlementStatusDate("");
    setRequestDate([]);
    setSettlementStatusDate([]);
    setValueMultiSelectResponse([]);
    queryClient.setQueryData(TABLE_FILTER_SUPP, null);
    fillData(queryClient.getQueryData(TABLE_FILTER_SUPP)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = new Filter();
  // filter.state = " []";
  filter.supplierSettlementStatus = [];
  filter.loanRequestStatus = [];
  filter.supplierIds = [];
  filter.loanTemplateIds = [];
  filter.loanRequestSources = [];
  const lessFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropUpIcon style={{ color: "#1D4A87" }} />
      فیلترهای کمتر{" "}
    </span>
  );
  const extraFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropDownIcon style={{ color: "#1D4A87" }} />
      فیلترهای بیشتر
    </span>
  );

  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  // let exportExcel = () => {
  //   ExportLoanRequestsMutation.mutate(
  //     valueFilterData ? valueFilterData! : new Filter()
  //   );
  // };
  return (
    <div>
      <Tooltip title='فیلتر' arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src='images/filter.png'
          alt=''
        />
      </Tooltip>
      {/* <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span> */}
      {/* <Tooltip title="خروجی اکسل" arrow>
        <img
          // onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
          alt=""
        />
      </Tooltip> */}
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values) => {
              if (
                requestDate != null &&
                (requestDate[0] != undefined || requestDate[1] != undefined)
              ) {
                values.requestDateFrom = convertToLocalDateTime(
                  Number(requestDate[0])
                );
                if (requestDate.length > 1) {
                  values.requestDateTo = convertToLocalDateTime(
                    Number(requestDate[1])
                  );
                } else {
                  values.requestDateTo = convertToLocalDateTime(
                    Number(requestDate[0])
                  );
                }
              } else {
                values.requestDateFrom = undefined;
                values.requestDateTo = undefined;
              }

              if (
                settlementStatusDate != null &&
                (settlementStatusDate[0] != undefined ||
                  settlementStatusDate[1] != undefined)
              ) {
                // values.settlementStatusDateFrom = convertToLocalDateTime(
                //   Number(settlementStatusDate[0])
                // );
                if (settlementStatusDate.length > 1) {
                  // values.settlementStatusDateFrom = convertToLocalDateTime(
                  //   Number(settlementStatusDate[1])
                  // );
                } else {
                  // values.settlementStatusDateFrom = convertToLocalDateTime(
                  //   Number(settlementStatusDate[0])
                  // );
                }
              } else {
                values.settlementStatusDateFrom = undefined;
                values.settlementStatusDateTo = undefined;
              }

              // values.requestDatePersian = valueRequestDate;
              // values.settlementStatusDatePersian = valueSettlementStatusDate;
              // values.requestDateArray = requestDate;
              // values.settlementStatusDateArray = settlementStatusDate;

              queryClient.setQueryData(TABLE_FILTER_SUPP, values);
              values.loanRequestStatus = valueMultiSelect;
              values.supplierSettlementStatus = valueSupplierSettlementStatus;
              // values.loanTemplateIds = valueLoanTemplateOptions;
              // values.valueLoanTemplate = valueLoanTemplate;
              // values.supplierIds = valueSupplierIds;
              // values.supplierName = valueSupplier;
              values.customerFullName = valueCustomerFullName;
              values.customerNationalCode = valueCustomerNationalCode;
              values.customerMobileNumber = valueCustomerMobileNumber;
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"نام و نام خانوادگی متقاضی"}
                      label={"نام و نام خانوادگی متقاضی"}
                      required={false}
                      value={valueCustomerFullName}
                      onChange={changeValueCustomerFullName}
                      name='customerFullName'
                      id='customerFullName'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name='customerNationalCode'
                      id='customerNationalCode'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"شماره همراه"}
                      label={"شماره همراه"}
                      required={false}
                      value={valueCustomerMobileNumber}
                      onChange={changeValueCustomerMobileNumber}
                      name='customerMobileNumber'
                      id='customerMobileNumber'
                    />
                  </div>

                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className='shadowDatepicker'>
                      <DatePickerComponents
                        valueArray={requestDate}
                        // value={new Date(valueRequestDateFrom!)}
                        label={" تاریخ درخواست "}
                        // onChange={(newValue: any) => {
                        //   setRequestDateFrom(newValue);
                        // }}
                        onChange={changeValueRequestDate}
                        range={true}
                      />
                    </FormControl>
                  </div>

                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir='rtl'>
                          <AutocomplateCheckbox
                            id='loanRequestStatus'
                            name='loanRequestStatus'
                            value={valueMultiSelect}
                            label='وضعیت تسهیلات'
                            options={loanRequestStatus}
                            onChange={changeMultiSelectChip}
                            changeMultiSelect={changeMultiSelectChip}
                            responseValue={valueMultiSelectResponse}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>

                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter'
                    style={{ marginTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant='contained'
                      type='submit'
                      className='btnForm SuccessDefault  '
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>
                {valueMultiSelect?.length ||
                valueSupplierSettlementStatus?.length ||
                valueLoanTemplateOptions?.length ||
                valueSupplierUserOptions?.length ||
                valueSupplierIds?.length ||
                valueCustomerFullName ||
                valueCustomerNationalCode ||
                valueCustomerMobileNumber ||
                valueRequestDate ||
                valueSettlementStatusDate ? (
                  <div className='row tableCMP'>
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src='images/RemoveAllFilters.svg'
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "-9px" }}
                      >
                        <ChipCmp
                          item={valueMultiSelect}
                          enamValue={loanRequestStatus}
                          index={valueMultiSelect?.length}
                          setChildValue={setChildValueStat}
                        />
                        <ChipCmp
                          item={valueSupplierSettlementStatus}
                          enamValue={supplierSettlementOptions}
                          index={valueSupplierSettlementStatus?.length}
                          setChildValue={setChildValueStatSettelment}
                        />
                        <ChipCmp
                          item={valueLoanTemplateOptions}
                          enamValue={loanTemplateOptions}
                          index={valueLoanTemplateOptions?.length}
                          setChildValue={setChildValueLoanTemplate}
                        />
                        <ChipCmp
                          item={valueSupplierIds}
                          enamValue={supplierIdsOptions}
                          index={valueSupplierIds?.length}
                          setChildValue={setChildValueSupplierIds}
                        />
                        <ChipCmp
                          item={valueCustomerFullName}
                          enamValue={valueCustomerFullName}
                          index={valueCustomerFullName?.length}
                          setChildValue={setChildValueCustomerFullName}
                        />
                        <ChipCmp
                          item={valueCustomerNationalCode}
                          enamValue={valueCustomerNationalCode}
                          index={valueCustomerNationalCode?.length}
                          setChildValue={setChildValueCustomerNationalCode}
                        />
                        <ChipCmp
                          item={valueCustomerMobileNumber}
                          enamValue={valueCustomerMobileNumber}
                          index={valueCustomerMobileNumber?.length}
                          setChildValue={setChildValueCustomerMobileNumber}
                        />
                        <ChipCmp
                          item={valueRequestDate}
                          enamValue={valueRequestDate}
                          index={valueRequestDate?.length}
                          setChildValue={setChildValueRequestDate}
                        />
                        <ChipCmp
                          item={valueSettlementStatusDate}
                          enamValue={valueSettlementStatusDate}
                          index={valueSettlementStatusDate?.length}
                          setChildValue={setChildValueSettlementStatusDate}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className='cardTableBorder'>
        <TableContainer
          style={{ background: "#fff", maxHeight: "55vh" }}
          className='boxScroll'
        >
          <Table
            stickyHeader
            aria-label='sticky table'
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className='rowTHead' style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                selected={selectedRow === 0}
              >
                <TableCell
                  className='rowTHead colorTitle textFont12 fontWeight WidthRowNumber'
                  align='right'
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  #
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className='rowTHead colorTitle textFont12 fontWeight noWrap'
                    key={column.id}
                    align='right'
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data
                ? data.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role='checkbox'
                        tabIndex={-1}
                        // key={row.creationDatePersian}
                        selected={selectedRow === rowIndex}
                        onClick={() =>
                          handleDetail(
                            row.referenceKey,
                            rowIndex,
                            row.loanRequestId,
                            row.customerNationalCode
                          )
                        }
                      >
                        <TableCell
                          className='textFont12 WidthRowNumber'
                          style={{ width: "10vh", minWidth: "10vh" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>
                        {columns.map((column) => {
                          const value =
                            row[column.id as keyof ChatSearchResponse];
                          return (
                            <TableCell
                              className='textFont12'
                              key={column.id}
                              align='right'
                            >
                              {column.format && column.hasFormat
                                ? column.format(value)
                                : value?.toString()}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems='center'>
          <Grid
            item
            xs={12}
            sm={4}
            display='flex'
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display='flex' justifyContent='center'>
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </div>
  );
}
interface TableCmpPropsInterface {
  stateCartable: any;
  status: any;
}
const mapStateToProps = ({ stateCartable, status }: TableCmpPropsInterface) => {
  return {
    stateCartable,
    status,
  };
};

export default withRouter(connect(mapStateToProps)(CommentsTable));
const onKeyDown = (e: any) => {
  e.preventDefault();
};
